import { OilFieldDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OilFieldService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getOilField(): Observable<OilFieldDto[]> {
    return this.http.get<OilFieldDto[]>(this.url + 'oil-field');
  }

  createOilField(data: OilFieldDto[]): Observable<OilFieldDto[]> {
    return this.http.post<OilFieldDto[]>(this.url + 'oil-field', data);
  }
  getSingleOilField(id: string): Observable<any> {
    return this.http.get(this.url + 'oil-field/' + id);
  }

  updateOilField(data: OilFieldDto[]): Observable<OilFieldDto[]> {
    return this.http.post<OilFieldDto[]>(this.url + 'oil-field/update', data);
  }

  deleteOilField(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('oil-field', ids.join(', '));
    return this.http.delete(this.url + 'oil-field', httpOptions);
  }
}
